import { RESET_USER_PASSWORD, RESET_PASSWORD_VALIDATION } from '../../../constants/ApplicationUrl';
import api from "../../../dependencies/utils/Api"


export const ResetPassword = {

    resetPassword80iac(email) {
        // const encodedEmail = encodeURIComponent(email);
        // const encodedPassword = encodeURIComponent(password);
        const url = `${RESET_USER_PASSWORD}?email=${email}`
        return api.GET(url, {}) 
        .then((response) => {
            const { data = {} } = response;
            return data;
            });
    },


}

export const ResetPasswordValidation = {

    resetPasswordValidation(password) {
        const url = `${RESET_PASSWORD_VALIDATION}?password=${password}`
        // const url = `${RESET_PASSWORD_VALIDATION}`
        return api.GET(url, {}) 
        .then((response) => {
            const { data = {} } = response;
            return data;
            });
    },

    
}